import { render } from "./ItemsView.vue?vue&type=template&id=e62fd278&ts=true"
import script from "./ItemsView.vue?vue&type=script&lang=ts"
export * from "./ItemsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__